module.exports = {
    strategy: 'SuperbetPartialPercentage',
    payer: 'Player',
    payOutTaxOnExpire: false,
    validation: {
        player: {
            firstName: {
                required: true
            },
            lastName: {
                required: true
            },
            cnp: {
                required: true,
                pattern: '^[0-9]{13}$'
            }
        }
    },
    taxAmountRoundDecimals: 0,
    rules: [
        {
            taxValue: 3,
            minApplyAmount: 0,
            limitAmount: 10000
        },
        {
            taxValue: 20,
            minApplyAmount: 10000,
            minApplyAmountInclude: true,
            limitAmount: 66750
        },
        {
            taxValue: 40,
            minApplyAmount: 66750,
            minApplyAmountInclude: true,
            limitAmount: 0
        }
    ]
};
